export const REQUEST_TIMEOUT = 60000; // default request timeout in ms, 1min
export const NETWORK_ERROR_REGEX = /network error/i;
export const REQUEST_ERROR_REGEX = /request aborted/i;
export const USER_ABORTED_REQUEST_ERROR = /The user aborted a request/i;

// axios sent this Accept header on every request it made; fetch() sends only
// `Accept: */*`. The endpoints behind these calls have only ever been asked for
// JSON-or-text, so the header is reproduced verbatim rather than narrowed, so
// that server-side content negotiation sees exactly what it saw before.
// Callers can override it through `headers`.
export const DEFAULT_ACCEPT_HEADER = 'application/json, text/plain, */*';
